import { NgModule } from '@angular/core';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { FunctionsModule, getFunctions, provideFunctions, } from '@angular/fire/functions';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';


@NgModule({
  imports: [
    FunctionsModule,
  ],
  providers:[
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      return getAuth();
    }),
    provideFirestore(() => {
      return getFirestore();
    }),
    provideDatabase(() => {
      return getDatabase();
    }),
    provideStorage(() => {
      return getStorage();
    }),
    provideFunctions(() => {
      return getFunctions(
        getApp(),
        'europe-west1',
      );
    }),
    provideMessaging(() => getMessaging()),
  ]
})
export class FirebaseModule { }
